import React from "react";
import { CalendarCheck } from "lucide-react";
export const FloatingButton = () => {
  return (
    <div className="fixed bottom-12 left-auto right-3 sm:bottom-6 z-20 flex flex-col space-y-2 sm:right-6">
      <a
        href={"https://drmohansdiabetes.co.in/enroll/?campname=website"}
        target="_blank"
        rel="noreferrer"
        className="shadow-sm mobile-only-icon flex items-center gap-3 rounded-full bg-secondary py-3 px-6 text-white"
      >
        <CalendarCheck />
        <span className="hide-on-small">Book an Appointment</span>
      </a>
      <a
        href="tel:919677188888"
        className="shadow-sm mobile-only-icon flex items-center gap-3 rounded-full bg-secondary py-3 px-3 text-base text-white sm:px-6"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 15 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-5"
          style={{ display: "inline-block" }}
        >
          <path
            d="M4.8268 7.08225C5.42685 8.20491 6.42886 9.11038 7.66956 9.65113C7.76108 9.69039 7.8623 9.70739 7.96327 9.70044C8.06424 9.69349 8.16147 9.66284 8.2454 9.61151L10.0677 8.50867C10.1482 8.4592 10.2412 8.42902 10.3381 8.42093C10.435 8.41285 10.5325 8.42713 10.6217 8.46245L14.033 9.78981C14.1496 9.83378 14.247 9.91124 14.3102 10.0103C14.3734 10.1093 14.3989 10.2245 14.3828 10.3379C14.2747 11.1025 13.8628 11.8051 13.2242 12.3144C12.5856 12.8237 11.764 13.1048 10.9132 13.1049C8.28407 13.1049 5.76261 12.1587 3.90352 10.4744C2.04443 8.7901 1 6.5057 1 4.12374C1.00019 3.35294 1.31038 2.60862 1.87253 2.03004C2.43467 1.45146 3.21026 1.07828 4.05415 0.980326C4.1794 0.96575 4.30647 0.988881 4.41579 1.04616C4.52511 1.10344 4.61062 1.19168 4.65914 1.29731L6.12426 4.3945C6.16236 4.47397 6.1783 4.56072 6.17067 4.64709C6.16305 4.73346 6.13209 4.81681 6.08053 4.88978L4.86324 6.56715C4.80905 6.64302 4.77724 6.73021 4.77086 6.82039C4.76448 6.91058 4.78374 7.00074 4.8268 7.08225V7.08225Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="hide-on-small">+91 96771 88888</span>
      </a>
    </div>
  );
};
